// extracted by mini-css-extract-plugin
module.exports = {"closeIconBar":"transcript_closeIconBar__Y4S6D","transcriptHeader":"transcript_transcriptHeader__bv716","transcriptText":"transcript_transcriptText__XpQE2"};